/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateScheduleEventData
 */
export interface UpdateScheduleEventData {
    /**
     * 
     * @type {Date}
     * @memberof UpdateScheduleEventData
     */
    dateStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateScheduleEventData
     */
    dateEnd?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateScheduleEventData
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScheduleEventData
     */
    description?: string | null;
    /**
     * What type(s) this schedule event is
     * @type {Array<string>}
     * @memberof UpdateScheduleEventData
     */
    types?: Array<UpdateScheduleEventDataTypesEnum>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateScheduleEventData
     */
    schedules?: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum UpdateScheduleEventDataTypesEnum {
    Announcement = 'Announcement',
    BusinessClosed = 'BusinessClosed',
    LeaveRestricted = 'LeaveRestricted'
}


/**
 * Check if a given object implements the UpdateScheduleEventData interface.
 */
export function instanceOfUpdateScheduleEventData(value: object): value is UpdateScheduleEventData {
    return true;
}

export function UpdateScheduleEventDataFromJSON(json: any): UpdateScheduleEventData {
    return UpdateScheduleEventDataFromJSONTyped(json, false);
}

export function UpdateScheduleEventDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScheduleEventData {
    if (json == null) {
        return json;
    }
    return {
        
        'dateStart': json['dateStart'] == null ? undefined : (new Date(json['dateStart'])),
        'dateEnd': json['dateEnd'] == null ? undefined : (new Date(json['dateEnd'])),
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'types': json['types'] == null ? undefined : json['types'],
        'schedules': json['schedules'] == null ? undefined : json['schedules'],
    };
}

  export function UpdateScheduleEventDataToJSON(json: any): UpdateScheduleEventData {
      return UpdateScheduleEventDataToJSONTyped(json, false);
  }

  export function UpdateScheduleEventDataToJSONTyped(value?: UpdateScheduleEventData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dateStart': value['dateStart'] == null ? undefined : ((value['dateStart']).toISOString()),
        'dateEnd': value['dateEnd'] == null ? undefined : ((value['dateEnd']).toISOString()),
        'title': value['title'],
        'description': value['description'],
        'types': value['types'],
        'schedules': value['schedules'],
    };
}

